import SpainOccupationCode from 'modules/contracts/store/models/SpainOccupationCode'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class OccupationCodes extends PayrollLegalEntityResource<SpainOccupationCode> {
  get cacheKey(): string {
    return 'occupationCodes'
  }

  model() {
    return SpainOccupationCode
  }

  fetchByLegalEntityIds(legalEntityIds: string[]) {
    this.fetch({ data: { legal_entity_ids: legalEntityIds } })
  }

  /**
   * @override
   * The PayrollLegalEntityResource class has a computed property called actives
   * that filters the resources by the isActive property. This property is not
   * present in the OccupationCodes model, so we override the actives property
   */
  get actives() {
    return this.models
  }
}

export { OccupationCodes }
